import type { ModuleRoute } from '../types';
import { GroupFieldsPage, SiteFieldsPage } from './FieldsPages';
import { NoticeEditorPage, NoticeLibraryPage, SiteNoticesPage } from './NoticePages';

/** Pages of this area. Owned by Phase 1 task W3; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/sites/:id/fields', element: <SiteFieldsPage />, permission: 'sites.view' },
  { path: '/manage/groups/:id/fields', element: <GroupFieldsPage />, permission: 'groups.view' },
  { path: '/manage/notices', element: <NoticeLibraryPage />, permission: 'notices.view' },
  { path: '/manage/notices/new', element: <NoticeEditorPage />, permission: 'notices.manage' },
  { path: '/manage/notices/:id', element: <NoticeEditorPage />, permission: 'notices.view' },
  { path: '/manage/sites/:id/notices', element: <SiteNoticesPage />, permission: 'notices.view' },
];
